import { HelpFeature, HelpModel } from '@/model/HelpModel';
import { useStoreSelector } from '@/store';
import { selectHelpRoutes } from '@/store/help/selectors';

const useHelp = (helpFeature: HelpFeature, topicId: string) => {
	//#region state management variables
	const helpRoutes = useStoreSelector<Map<HelpFeature, HelpModel[]>>(selectHelpRoutes);
	//#endregion

	let dataSource: HelpModel[] = [];
	if (helpRoutes) {
		const data = helpRoutes[HelpFeature[helpFeature]];
		if (data?.length) {
			dataSource = data;
		}
	}

	const topicIdIsEmpty = !topicId?.length;
	const helpModel: HelpModel[] = dataSource.filter(x => (topicIdIsEmpty && x.ShowMain) || (!topicIdIsEmpty && x.Id === topicId));

	return helpModel;
};

export { useHelp };
